import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'
import { Card, CardContent, Box, Typography } from '@material-ui/core'
import { displayLegs } from './utilities'
import { formatPrice } from '../../utils/helpers'
import StakeInput from './StakeInput'
import theme from '../../utils/theme'

const CardBase = styled(Card)`
  margin: ${props => props.theme.spacing(3)}px;
  .MuiCardContent-root {
    padding: ${props => props.theme.spacing(3)}px
      ${props => props.theme.spacing(4)}px;
  }
`
const CardTitle = styled(Typography)`
  flex: 1;
  padding-right: ${props => props.theme.spacing(2)}px;
`
const CardInput = styled.div`
  width: 100px;
  margin-left: 8px;
`
const Returns = styled(Typography)`
  text-align: right;
  margin-left: auto;
`

const Multiples = props => {
  const { bets, multiBets, setMultiBets, disabled } = props
  const { stake } = multiBets.straight

  // Cont of bets
  const betsCount = Object.keys(bets).length
  // Check how many of the bets are from a unique event
  const validBets = _.uniq(Object.keys(bets).map(key => bets[key].id))

  // Calculate the multi odds for a straight bet
  const combinedOdds = Object.keys(bets).reduce((total, index) => {
    const bet = bets[index]
    if (!bet.odds) {
      return total
    }
    return total * bet.odds
  }, 1)

  // Calculate returns
  const returns = stake * combinedOdds || 0

  // Handle the multi bet stake input by utilising the multiBets hook
  const handleMultiBetInput = input => {
    setMultiBets({
      ...multiBets,
      straight: {
        title: displayLegs(validBets.length),
        stake: parseFloat(input) || 0,
        odds: combinedOdds,
        bets,
      },
    })
  }

  // Check for conflicting legs
  if (validBets.length !== betsCount) {
    return (
      <CardBase>
        <CardContent>
          <Typography variant="body2" color="textPrimary">
            One or more of your selections are related and cannot be combined
            into a multibet
          </Typography>
        </CardContent>
      </CardBase>
    )
  }

  return (
    <CardBase>
      <CardContent>
        <Box display="flex" alignItems="center">
          <CardTitle variant="subtitle1" color="textPrimary">
            {displayLegs(validBets.length)} @ {formatPrice(combinedOdds * 100)}
          </CardTitle>
          <CardInput>
            <StakeInput
              stake={stake}
              inputHandler={handleMultiBetInput}
              disabled={disabled}
            />
          </CardInput>
        </Box>
        <Box display="flex" alignItems="center" pt={1}>
          <Returns variant="body2" color="textSecondary" noWrap>
            Returns {formatPrice(returns * 100)}
          </Returns>
        </Box>
      </CardContent>
    </CardBase>
  )

  // Will need to filter out the duplicate event ids
  // Then a reduce to multiple the odds
}

Multiples.propTypes = {
  bets: PropTypes.object,
  multiBets: PropTypes.object,
  setMultiBets: PropTypes.func,
  disabled: PropTypes.bool,
}

export default Multiples
